import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const EXTRACTOR_ID_MAX_LENGTH = 64;

export const upsertExtractorVendorMappingSchema = () =>
  yup.object().shape({
    id: yup.number().nullable(),
    // Opaque string end to end (AlgoDocs sends values such as `cbxy8ocqm4ls475z179fyagx`), never a
    // number. `.trim()` runs as a transform, so a whitespace-only value fails `.required()` here
    // instead of reaching the BE as an empty extractor id.
    extractorId: yup
      .string()
      .label(t('labelExtractorId'))
      .trim()
      .max(EXTRACTOR_ID_MAX_LENGTH)
      .nullable()
      .required(getEmptyErrorMessage(t('labelExtractorId'))),
    // Both targets are optional and independent — vendor-only, contact-only, both and neither are
    // all legal rows. A bare `yup.object()` would default to `{}`, which the payload mapper cannot
    // tell apart from a picked value.
    vendorLocation: yup.object().label(t('labelVendor')).nullable().default(undefined),
    contact: yup.object().label(t('labelVendorContact')).nullable().default(undefined),
  });
